import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-55d10786")
const _hoisted_1 = { class: "inquiry section-wrapper contents__area" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "titleHead titleHead--terms" }, "お問い合わせ")
], -1)
const _hoisted_3 = {
  class: "inquiryForm formFrame formFrame--input fadein-js fade-in",
  autocomplete: "on"
}
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "companyName" }, "会社名", -1)
const _hoisted_7 = { class: "form-item-body" }
const _hoisted_8 = { class: "form-item-error" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 入力してください。")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = { class: "form-item-header" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "担当者氏名", -1)
const _hoisted_15 = { class: "form-item-body" }
const _hoisted_16 = { class: "form-item-error" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("入力してください。")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "form-item" }
const _hoisted_21 = { class: "form-item-header" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "nameKana" }, "担当者氏名(ふりがな)", -1)
const _hoisted_23 = { class: "form-item-body" }
const _hoisted_24 = { class: "form-item-error" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("入力してください。")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "form-item" }
const _hoisted_29 = { class: "form-item-header" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "phoneNumber" }, "電話番号", -1)
const _hoisted_31 = { class: "form-item-body" }
const _hoisted_32 = { class: "phoneNumber__item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "hyphen" }, "-", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "hyphen" }, "-", -1)
const _hoisted_35 = { class: "form-item-error" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("入力してください。")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("正しい電話番号を入力してください。")
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "form-item" }
const _hoisted_43 = { class: "form-item-header" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "メールアドレス", -1)
const _hoisted_45 = { class: "form-item-body" }
const _hoisted_46 = { class: "form-item-error" }
const _hoisted_47 = { class: "form-item-error" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("入力してください。")
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "form-item-error" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("正しいメールアドレスを入力してください。")
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "form-item" }
const _hoisted_56 = { class: "form-item-header" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "inquiryType" }, "お問い合わせの種類", -1)
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode("利用申込み ")
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode("サービス詳細説明希望 ")
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode("デモ画面紹介希望 ")
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode("代理店販売について ")
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode("その他 ")
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode("無料相談 ")
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode("詳細説明 ")
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "radio-icon" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode("その他 ")
const _hoisted_76 = { class: "form-item-error" }
const _hoisted_77 = { class: "form-item-error" }
const _hoisted_78 = { class: "formFrame__item" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "form-item-header" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "notes" }, "お問い合わせ内容")
], -1)
const _hoisted_80 = { class: "form-item-body" }
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<div class=\"consentConfirm\" data-v-55d10786><ul data-v-55d10786><li class=\"detail\" data-v-55d10786><i class=\"fas fa-exclamation-triangle\" data-v-55d10786></i><div class=\"detailText\" data-v-55d10786> メールアドレスをお間違えになると回答の送信ができません。 </div></li><li class=\"detail\" data-v-55d10786><i class=\"fas fa-exclamation-triangle\" data-v-55d10786></i><div class=\"detailText\" data-v-55d10786> フォーム送信前にいま一度、正しいメールアドレスかどうかをご確認ください。 </div></li><li class=\"detail\" data-v-55d10786><i class=\"fas fa-exclamation-triangle\" data-v-55d10786></i><div class=\"detailText\" data-v-55d10786> 迷惑メール対策を実施されている方は「@linku-s.com」のメールが受信できるように設定してください。 </div></li><li class=\"detail\" data-v-55d10786><i class=\"fas fa-exclamation-triangle\" data-v-55d10786></i><div class=\"detailText\" data-v-55d10786> 一部のプロバイダー等では、メールサーバー上でメールをブロックしてしまうことがあります。その際は、ご利用のプロバイダーやメールサーバーの管理者にお問い合わせください。 </div></li></ul></div>", 1)
const _hoisted_82 = { class: "formButton" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_required_label = _resolveComponent("required-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_required_label)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.companyName = $event)),
            type: "text",
            id: "companyName",
            name: "companyName",
            class: _normalizeClass(["inputField inputField--text", {
              error_form:
                _ctx.formStatuses.companyName.touched &&
                !_ctx.formStatuses.companyName.required,
            }]),
            required: "required",
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formStatuses.companyName.touched = true)),
            "max-length": "50"
          }, null, 34), [
            [_vModelText, _ctx.formData.companyName]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("span", null, _hoisted_11, 512), [
            [_vShow, 
              _ctx.formStatuses.companyName.touched &&
                !_ctx.formStatuses.companyName.required
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_required_label)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.name = $event)),
            type: "text",
            id: "name",
            name: "name",
            class: _normalizeClass(["inputField inputField--text", {
              error_form:
                _ctx.formStatuses.name.touched && !_ctx.formStatuses.name.required,
            }]),
            required: "required",
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formStatuses.name.touched = true)),
            "max-length": "30"
          }, null, 34), [
            [_vModelText, _ctx.formData.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("span", null, _hoisted_19, 512), [
            [_vShow, _ctx.formStatuses.name.touched && !_ctx.formStatuses.name.required]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_required_label)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.nameKana = $event)),
            type: "text",
            id: "nameKana",
            name: "nameKana",
            class: _normalizeClass(["inputField inputField--text", {
              error_form:
                _ctx.formStatuses.nameKana.touched &&
                !_ctx.formStatuses.nameKana.required,
            }]),
            required: "required",
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.formStatuses.nameKana.touched = true)),
            "max-length": "60"
          }, null, 34), [
            [_vModelText, _ctx.formData.nameKana]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("span", null, _hoisted_27, 512), [
            [_vShow, 
              _ctx.formStatuses.nameKana.touched && !_ctx.formStatuses.nameKana.required
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_required_label)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              required: "required",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.phoneNumber1 = $event)),
              type: "text",
              id: "phoneNumber1",
              name: "phoneNumber",
              class: _normalizeClass(["inputField inputField--text", {
                error_form:
                  (_ctx.phoneNumberAllTouched &&
                    !_ctx.formStatuses.phoneNumber.required) ||
                  (_ctx.phoneNumberAllTouched && !_ctx.formStatuses.phoneNumber.format),
              }]),
              maxlength: "4",
              onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formStatuses.phoneNumber1.touched = true)),
              "max-length": "20"
            }, null, 34), [
              [_vModelText, _ctx.phoneNumber1]
            ]),
            _hoisted_33,
            _withDirectives(_createElementVNode("input", {
              required: "required",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.phoneNumber2 = $event)),
              type: "text",
              id: "phoneNumber2",
              name: "phoneNumber",
              class: _normalizeClass(["inputField inputField--text", {
                error_form:
                  (_ctx.phoneNumberAllTouched &&
                    !_ctx.formStatuses.phoneNumber.required) ||
                  (_ctx.phoneNumberAllTouched && !_ctx.formStatuses.phoneNumber.format),
              }]),
              maxlength: "4",
              onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formStatuses.phoneNumber2.touched = true)),
              "max-length": "20"
            }, null, 34), [
              [_vModelText, _ctx.phoneNumber2]
            ]),
            _hoisted_34,
            _withDirectives(_createElementVNode("input", {
              required: "required",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.phoneNumber3 = $event)),
              type: "text",
              id: "phoneNumber3",
              name: "phoneNumber",
              class: _normalizeClass(["inputField inputField--text", {
                error_form:
                  (_ctx.phoneNumberAllTouched &&
                    !_ctx.formStatuses.phoneNumber.required) ||
                  (_ctx.phoneNumberAllTouched && !_ctx.formStatuses.phoneNumber.format),
              }]),
              maxlength: "4",
              onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formStatuses.phoneNumber3.touched = true)),
              "max-length": "20"
            }, null, 34), [
              [_vModelText, _ctx.phoneNumber3]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _withDirectives(_createElementVNode("span", null, _hoisted_38, 512), [
              [_vShow, 
                _ctx.phoneNumberAllTouched && !_ctx.formStatuses.phoneNumber.required
              ]
            ]),
            _withDirectives(_createElementVNode("span", null, _hoisted_41, 512), [
              [_vShow, 
                _ctx.phoneNumberAllTouched &&
                  _ctx.formStatuses.phoneNumber.required &&
                  !_ctx.formStatuses.phoneNumber.format
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createVNode(_component_required_label)
        ]),
        _createElementVNode("div", _hoisted_45, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.email = $event)),
            type: "email",
            id: "email",
            name: "email",
            class: _normalizeClass(["inputField inputField--mail-address", {
              error_form:
                (_ctx.formStatuses.email.touched && !_ctx.formStatuses.email.required) ||
                (_ctx.formStatuses.email.touched && !_ctx.formStatuses.email.format),
            }]),
            required: "required",
            onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.formStatuses.email.touched = true)),
            "max-length": "255"
          }, null, 34), [
            [_vModelText, _ctx.formData.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _withDirectives(_createElementVNode("span", _hoisted_47, _hoisted_50, 512), [
            [_vShow, _ctx.formStatuses.email.touched && !_ctx.formStatuses.email.required]
          ]),
          _withDirectives(_createElementVNode("span", _hoisted_51, _hoisted_54, 512), [
            [_vShow, 
              _ctx.formStatuses.email.touched &&
                _ctx.formStatuses.email.required &&
                !_ctx.formStatuses.email.format
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createVNode(_component_required_label)
        ]),
        (_ctx.formData.serviceName === 'linkus')
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_58, [
              _createElementVNode("label", {
                for: "inqurytype01",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === '利用申込み',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype01",
                  name: "inquiryType",
                  value: "利用申込み",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_59,
                _hoisted_60
              ], 2),
              _createElementVNode("label", {
                for: "inqurytype02",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === 'サービス詳細説明希望',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype02",
                  name: "inquiryType",
                  value: "サービス詳細説明希望",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_61,
                _hoisted_62
              ], 2),
              _createElementVNode("label", {
                for: "inqurytype03",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === 'デモ画面紹介希望',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype03",
                  name: "inquiryType",
                  value: "デモ画面紹介希望",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_63,
                _hoisted_64
              ], 2),
              _createElementVNode("label", {
                for: "inqurytype04",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === '代理店販売について',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype04",
                  name: "inquiryType",
                  value: "代理店販売について",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_65,
                _hoisted_66
              ], 2),
              _createElementVNode("label", {
                for: "inqurytype05",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === 'その他',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype05",
                  name: "inquiryType",
                  value: "その他",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_67,
                _hoisted_68
              ], 2),
              _withDirectives(_createElementVNode("input", {
                type: "hidden",
                id: "serviceName",
                name: "serviceName",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formData.serviceName = $event))
              }, null, 512), [
                [_vModelText, _ctx.formData.serviceName]
              ])
            ]))
          : (_openBlock(), _createElementBlock("fieldset", _hoisted_69, [
              _createElementVNode("label", {
                for: "inqurytype06",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === '無料相談',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype06",
                  name: "inquiryType",
                  value: "無料相談",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_70,
                _hoisted_71
              ], 2),
              _createElementVNode("label", {
                for: "inqurytype07",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === '詳細説明',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype07",
                  name: "inquiryType",
                  value: "詳細説明",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_72,
                _hoisted_73
              ], 2),
              _createElementVNode("label", {
                for: "inqurytype08",
                class: _normalizeClass({
              'radio-input': true,
              checked: _ctx.formData.inquiryType === 'その他',
            })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "inqurytype08",
                  name: "inquiryType",
                  value: "その他",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.formData.inquiryType = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.formData.inquiryType]
                ]),
                _hoisted_74,
                _hoisted_75
              ], 2),
              _withDirectives(_createElementVNode("input", {
                type: "hidden",
                id: "serviceName",
                name: "serviceName",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.formData.serviceName = $event))
              }, null, 512), [
                [_vModelText, _ctx.formData.serviceName]
              ])
            ])),
        _createElementVNode("div", _hoisted_76, [
          _withDirectives(_createElementVNode("span", _hoisted_77, "入力してください。", 512), [
            [_vShow, 
              _ctx.formStatuses.inquiryType.touched &&
                !_ctx.formStatuses.inquiryType.required
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_78, [
        _hoisted_79,
        _createElementVNode("div", _hoisted_80, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.formData.notes = $event)),
            id: "notes",
            name: "notes",
            rows: "10",
            cols: "55",
            class: "inputField inputField--textarea"
          }, null, 512), [
            [_vModelText, _ctx.formData.notes]
          ])
        ])
      ]),
      _hoisted_81,
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("button", {
          type: "button",
          class: "buttonItem buttonItem--result",
          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, " 確認画面へ ")
      ])
    ])
  ]))
}